import React from "react";

const experience = () => {
  return (
    <div id="experience">
      <h2>Experience</h2>
      <div>
        <h3>WordPress Plugin Developer</h3>
        <ul>
          <li>
            Worked on an open-source WordPress plugin to generate pages with a
            single click.
          </li>
          <li>
            The plugin helps to manage large scaled contents of the multiple
            pages.
          </li>
          <li>
            The plugin handles the optimization of the SEO for each generated
            pages.
          </li>
          <li>
            The plugin generates multiple pages using uploaded CSV and excel
            file
          </li>
          <li>
            Lead a group of 4 developers and managed the project using ​Agile
            Scrum​​ methodology.
          </li>
          <li>
            Perform system analysis, requirement clarification, estimation,
            design, and documentation.
          </li>
        </ul>
        <p>
          PHP, Javascript, MySQL, JSON, CSV, Excel Reader framework, Wordpress
          and UI/UX design.
        </p>

        <p>
          Links:{" "}
          <a
            href="https://wordpress.org/plugins/multiple-page-generator"
            target="new_tab"
          >
            WordPress
          </a>{" "}
          ||{" "}
          <a
            href="https://github.com/sbotiroff/Multiple-Page-Generator-Wordpress-Plugin"
            target="new_tab"
          >
            GitHub
          </a>
        </p>
      </div>
      <div>
        <h3>Wordpress Developer</h3>
        <ul>
          <li>Worked on Online blog of the "Culture of Uzbekistan".</li>
          <li>Build a fully functional and scalable online shop.</li>
          <li>
            Responsive and mobile-first design with to showing the beautiful
            culture of Uzbekistan
          </li>
          <li>Highline Award winner blog</li>
        </ul>
      </div>
    </div>
  );
};

export default experience;
